import React from "react";

import Form from "./form";

import { connect } from "react-redux";
import {
    updateXtm,
    loadXtm,
    reset,
    getData,
    getFormSuccess,
    isLoading,
    isLoaded,
    getError,
} from "../../../../redux/actions/job/form";

import { isNotValid, translateSymfonyErrorToFormik } from "../../../../core/utils/form";

import Loader from "../../../../components/loader";

/**
 * Container:
 *
 *   Se encarga de la conexion entre Redux y el Componente  que presenta los datos
 *
 * De paso en algunos caso, excepto formularios se maneja el Loading y el título.
 *
 * OBS: En formularios es mejor que el 'loading' lo maneje el formulario dado que Formik
 *    si se redibuja pierde los datos, entonces hay que tener cuidado con eso.
 */
class Container extends React.Component {
    constructor(props) {
        super(props);
        this.state = { id: props.match.params.id };
    }

    componentDidMount() {
        this.props.loadXtm(this.state.id);
    }

    _goBack = () => {
        this.props.reset();
        this.props.history.goBack();
    };

    componentWillUnmount() {
        this.props.reset();
    }

    /**
     * Función que maneja el submit del formulario
     *
     * Recordar que se puede tratar de un alta o una edición
     */
    _handleSubmit = (values, bag) => {
        const form = {
            ...values,
        };

        const ret = this.props.updateXtm(this.state.id, JSON.stringify(form));

        ret.then((response) => {
            if (isNotValid(response)) {
                bag.setErrors(translateSymfonyErrorToFormik(response.errors.children));
            } else {
                if (this.props.success) {
                    this._goBack();
                    return;
                }
            }
            bag.setSubmitting(false);
        }).catch((e) => {
            alert("Se ha producido un error desconocido");
        });
    };

    render() {
        const { data, loading, loaded } = this.props;
        return (
            <>
                <Loader loading={loading} />
                {!loading && loaded && data && <Form {...this.props} handleSubmit={this._handleSubmit} />}
            </>
        );
    }
}

function MapStateToProps(state) {
    return {
        error: getError(state),
        data: getData(state),
        loading: isLoading(state),
        loaded: isLoaded(state),
        success: getFormSuccess(state),
    };
}

const mapDispatchToProps = {
    reset,
    loadXtm,
    updateXtm,
};

export default connect(MapStateToProps, mapDispatchToProps)(Container);
